import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ListView } from '../list-view/list-view';
import { UserService } from '../shared/services/user-service';
import { HttpClient } from '@angular/common/http';
import { EnvironmentUrl } from '../shared/services/environment-url';

@Component({
  selector: 'app-list-users',
  imports: [ListView],
  templateUrl: './list-users.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './list-users.css',
})
export class ListUsers {
  userService?: UserService;

  constructor(
    private http: HttpClient,
    private envUrl: EnvironmentUrl,
  ) {
    this.userService = new UserService(this.http, this.envUrl);
  }
}
